import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '官方入口', path: '/category/official-entry' },
      { label: '备用线路', path: '/category/backup-links' },
      { label: '社区资源', path: '/category/community-resources' },
      { label: '移动端入口', path: '/category/mobile-access' },
    ],
  },
  {
    title: '资讯中心',
    links: [
      { label: '最新资讯', path: '/category/latest-news' },
      { label: '使用教程', path: '/category/tutorials' },
      { label: '热门文章', path: '/category/latest-news' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '关于我们', path: '/about' },
      { label: '品牌介绍', path: '/about' },
      { label: '联系我们', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/80 border-t border-background-300/60">
      <div className="container-custom py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 no-underline mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-heart-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl text-foreground-900 whitespace-nowrap">
                爱情岛导航
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              最全的爱情岛论坛入口聚合导航站，为您提供官方地址、备用线路及社区资源的一站式导航服务。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-base text-foreground-900 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 爱情岛论坛导航. 本站为第三方导航网站，非爱情岛论坛官方网站。
          </p>
          <p className="text-xs text-foreground-500">
            收藏本页，永不迷路
          </p>
        </div>
      </div>
    </footer>
  );
}